import { render } from "./CommentCharCounter.vue?vue&type=template&id=f8d37896"
import script from "./CommentCharCounter.vue?vue&type=script&lang=js"
export * from "./CommentCharCounter.vue?vue&type=script&lang=js"

import "./CommentCharCounter.vue?vue&type=style&index=0&id=f8d37896&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__